module.exports = __webpack_public_path__ + "vue-app/img/arrow-right.67d9daf1.svg";